module.exports = require("./he-IL.js");